import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What exactly is Generative AI and how is it different from regular AI?",
   
    description:
      "Generative AI creates new content—text, images, audio, or code—by learning patterns from large datasets. Unlike traditional AI, which focuses on prediction or classification, models like GPT, DALL·E, and Stable Diffusion generate creative, human-like outputs.",
  },
  {
    title: "What are the main technologies or concepts used in Generative AI?",
    
    description:
      "Generative AI uses transformers, attention mechanisms, embeddings, diffusion models, and neural networks. It also involves working with LLMs, tokenization, and autoencoders. These technologies help AI understand context and generate realistic, meaningful content.",
  },
  {
    title: "How do companies actually use Generative AI in their daily operations?",
    
    description:
      "Businesses use Generative AI to automate customer support, generate marketing content, analyze documents, create product descriptions, assist with coding, design prototypes, summarize reports, and build chatbots. It boosts efficiency by reducing repetitive tasks and accelerating creative and analytical workflows.",
  },
  {
    title: "What are the biggest challenges when working with Generative AI?",
    
    description:
      "Generative AI challenges include managing large datasets, preventing hallucinations, ensuring safe outputs, handling model limitations, and optimizing inference speed. Developers must also follow ethical guidelines and build scalable, secure, and reliable systems as they gain experience.",
  },
  {
    title: "Is Generative AI safe to use, and what ethical issues should I know about?",
    
    description:
      "Generative AI may produce biased or inaccurate outputs, making ethical practices essential. Learners study hallucinations, bias detection, responsible model use, data privacy, and human verification. Ethical awareness is increasingly crucial as the industry prioritizes safe and reliable AI systems.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
